import "./VerticalLine.css";

interface VerticalLineProps {
  height?: string;
}

export const VerticalLine = ({ height }: VerticalLineProps) => {
  const styles = {
    height: height || "auto",
  };
  return <div className="vertical-line" style={styles}></div>;
};
